import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, inject, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { SsrMarkToUnwrapDirective } from './ssr-markto-unwrap.directive';
import { MAILGUN_BLOCK_SCOPE_MARKER } from '../mailgun/constants';
import type { WrappedValue } from '../mailgun/wrap-value';
import { TemplateRendererConfig } from '../providers/template-renderer-config';

export type TemplateContext = {
  $implicit: WrappedValue<any>; // "item"
  template: TemplateRef<any>;
  prop: WrappedValue<any[]>;
  index: WrappedValue<number>;
  first: WrappedValue<boolean>;
  last: WrappedValue<boolean>;
};

@Component({
  template: `
    <ng-template
      #interpolateEach
      let-context
      let-template="template"
      let-first="first"
      let-last="last"
      let-index="index"
    >
      <ng-container
        *ngTemplateOutlet="
          template;
          context: { $implicit: context, first: first, last: last, index: index }
        "
      />
    </ng-template>

    <ng-template
      #mailgunEach
      let-context
      let-template="template"
      let-first="first"
      let-last="last"
      let-index="index"
      let-ownPath="ownPath"
    >
      <marker emailSsrMarkToUnwrap [innerHTML]="getMailgunEachStart(ownPath)"></marker>
      <ng-container
        *ngTemplateOutlet="
          template;
          context: { $implicit: context, first: first, last: last, index: index }
        "
      ></ng-container>
      <marker emailSsrMarkToUnwrap [innerHTML]="getMailgunEachEnd()"></marker>
    </ng-template>

    <ng-template #empty></ng-template>
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  imports: [NgTemplateOutlet, SsrMarkToUnwrapDirective],
})
export class EmailMailgunEachComponent {
  public config = inject(TemplateRendererConfig);
  public sanitizer = inject(DomSanitizer);

  @ViewChild('interpolateEach', { static: true })
  public interpolateEach: TemplateRef<TemplateContext>;
  @ViewChild('mailgunEach', { static: true }) public mailgunEach: TemplateRef<
    TemplateContext & { ownPath: string }
  >;

  public trackBy(index: number) {
    return index;
  }

  public getMailgunEachStart(ownPath: string) {
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustHtml(
      `<!-- ${MAILGUN_BLOCK_SCOPE_MARKER} {{#each ${ownPath} }} -->`,
    );
  }

  public getMailgunEachEnd() {
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustHtml(
      `<!-- ${MAILGUN_BLOCK_SCOPE_MARKER} {{/each}} -->`,
    );
  }
}
